import React from "react";
import { useForm } from "react-hook-form";
import { REGEX_EMAIL, REQUIRED_FIELD } from "helper/Validation";
import InputField from "components/ui/forms/InputField";
import Button from "components/ui/Button";

const DepositWithdrawForm = ({ onSubmit }) => {
  const {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });
  const watchAmount = watch("amount");

  return (
    <form className="" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <div className=" pr-1 mt-[15px]">
        <div className="grid grid-cols-1 gap-y-2 mb-6">
          <InputField
            name="email"
            label="E-mail"
            className="max-w-[560px] rounded"
            control={control}
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: REGEX_EMAIL,
                message: "Please enter a valid email address",
              },
            })}
            error={errors.username?.message}
          />
          <InputField
            type="text"
            name="amount"
            label="Amount"
            className="max-w-[560px]"
            control={control}
            {...register("amount", {
              required: REQUIRED_FIELD,
            })}
          />
        </div>
        <div className="w-full z-10 bottom-0">
          <Button
            label={"Deposit"}
            type="submit"
            size="small"
            variant="green"
            className="uppercase md:max-w-[370px] w-full"
            disabled={!watchAmount || errors.amount}
          />
        </div>
      </div>
    </form>
  );
};

export default DepositWithdrawForm;
